import React, { FC, ReactNode, memo, useEffect } from 'react';
import styles from './EnvelopesTable.module.scss'

import { useTranslation } from 'react-i18next';

import {
  Checkbox, getCheckboxCheckedValue,
  LibFixedType,
  LibScrollPositionType,
  Loader,
  Table
} from '@infologistics/frontend-libraries'

import { useAppDispatch, useAppSelector } from '@hooks/redux';

import {
  resetEnvelopes,
  setCurrentBoxOguid,
} from '@store/modules/envelopes';

import { EnvelopeItem } from '@views/envelopes';
import { useCheckboxes } from '@hooks/envelopes';

import EnvelopesPagination from './EnvelopesPagination';

import { IEnvelopesTableProps as IProps } from '@views/envelopes/types';
import cn from 'classnames';
import { useParams } from 'react-router';

const EnvelopesTable: FC<IProps> = ({ envelopes, declineInProgress, onOpenDeclineModal }) => {
  const { t } = useTranslation(['envelopes'])
  const {
    headCheckbox,
    setHeadCheckbox,
    checkedEnvelopes,
    selectedCheckbox
  } = useCheckboxes()

  const { asideWidth } = useAppSelector(state => state.user.settings);
  const modalId = useAppSelector(state => state.modal.modal);
  const { boxOguid } = useParams();
  const currentBoxOguid = boxOguid ?? '';

  const dispatch = useAppDispatch()

  const selectAllCheckbox = (): ReactNode =>
    <Checkbox
      checked={getCheckboxCheckedValue(headCheckbox ?? false)}
      name='checkAllEnvelopes'
      onChange={() => setHeadCheckbox(!headCheckbox)}
      value='selectAllEnvelopes'
    />

  const headings = [
    { class: styles.checkbox, content: selectAllCheckbox() },
    { class: styles.icons, content: '' },
    { content: t('envelopes:table:head:subject') },
    { class: styles.status, content: t('envelopes:table:head:status') },
    { class: styles.lastChange, content: t('envelopes:table:head:lastChange') },
    { class: styles.actions, content: t('envelopes:table:head:actions') },
  ]

  useEffect(() => {
    return () => {
      dispatch(resetEnvelopes())
    }
  }, [])

  useEffect(() => {
    dispatch(setCurrentBoxOguid(currentBoxOguid));
  }, [currentBoxOguid]);

  return (
    <div className={cn('overflow-y-scroll relative scrollbar-content', styles.wrapper)}>
      <Table
        fixedType={LibFixedType.SCROLLING_TAB}
        headings={headings}
        customScroll
        pagination={<EnvelopesPagination />}
        scrollPosition={LibScrollPositionType.FIXED}
        scrollContentClasses='mb-8'
        isUpdateTableY
        recalcTrigger={asideWidth}
      >
        {
          envelopes.map((envelope, idx) => (
            <EnvelopeItem
              idx={idx}
              key={envelope.oguid}
              envelope={envelope}
              checkbox={checkedEnvelopes[envelope.oguid]}
              selectedCheckbox={selectedCheckbox}
              onOpenDeclineModal={onOpenDeclineModal}
            />
          ))
        }
      </Table>
      {declineInProgress && !modalId && <Loader loading={true} /> }
    </div>
  )
}

const EnvelopesTableMemo = memo(EnvelopesTable)

export default EnvelopesTableMemo
